var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76672 1.08042C7.00357 1.23055 7.07127 1.54017 6.91785 1.77192L3.60723 6.77188C3.52011 6.90325 3.37537 6.98725 3.21581 6.99862C3.20329 6.99962 3.19064 7 3.17825 7C3.03185 7 2.89197 6.93863 2.79462 6.83025L1.12737 4.97589C0.940984 4.76852 0.961551 4.45265 1.17336 4.27015C1.38568 4.08765 1.70837 4.10815 1.89463 4.31527L3.11629 5.67401L6.06001 1.22817C6.2137 0.996423 6.53013 0.930298 6.76672 1.08042Z",
    fill: "#fff",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone2);
export default __webpack_public_path__ + "static/media/done2.73f16f0086fddf5ebd781347cfbd031b.svg";
export { ForwardRef as ReactComponent };